/* global toastr */

import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { createHashRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom"
import { configureStore } from '@reduxjs/toolkit'
import './style.css'
import IndexView from './index_view'
import Select2NavigationCleanup from './lib/Select2NavigationCleanup'
import { installSelect2ScrollFix } from './lib/select2Modal'

import { reducer as libReducer } from './smart_bps/lib'
import { reducer as choiceReducer } from './smart_bps/choice'
import { reducer as authReducer } from './auth'
import { reducer as adminReducer } from './admin'
import { reducer as territoriesReducer } from './territories'
import { reducer as modesReducer } from './modes'
import { reducer as contractorsReducer } from './contractors'
import { reducer as accessObjectsReducer } from './access_objects'
import { reducer as objectGroupsReducer } from './object_groups'
import { reducer as requestsReducer } from './requests'
import { reducer as approvalsReducer } from './approvals'
import { reducer as grantedAccessesReducer } from './granted_accesses'
import { reducer as tasksReducer } from './tasks'
import { reducer as autoparkReducer } from './autopark'
import { reducer as skudReducer } from './skud'
import { reducer as docsReducer } from './docs'
import { reducer as reportsReducer } from './reports'

import { routes as authRoutes } from './auth'
import { routes as adminRoutes } from './admin'
import { routes as territoriesRoutes } from './territories'
import { routes as modesRoutes } from './modes'
import { routes as contractorsRoutes } from './contractors'
import { routes as accessObjectsRoutes } from './access_objects'
import { routes as objectGroupsRoutes } from './object_groups'
import { routes as requestsRoutes } from './requests'
import { routes as approvalsRoutes } from './approvals'
import { routes as grantedAccessesRoutes } from './granted_accesses'
import { routes as tasksRoutes } from './tasks'
import { routes as autoparkRoutes } from './autopark'
import { routes as skudRoutes } from './skud'
import { routes as docsRoutes } from './docs'
import { routes as reportsRoutes } from './reports'

const LOGOUT_TOAST_GRACE_MS = 5000

function beginLogoutToastGracePeriod() {
  try {
    sessionStorage.setItem('sigur_logout_pending', '1')
    window.setTimeout(() => {
      sessionStorage.removeItem('sigur_logout_pending')
    }, LOGOUT_TOAST_GRACE_MS)
    if (typeof toastr !== 'undefined' && typeof toastr.clear === 'function') {
      toastr.clear()
    }
  } catch (e) {
    // sessionStorage может быть недоступен
  }
}

export const store = configureStore({
  reducer: {
    lib: libReducer,
    choice: choiceReducer,
    auth: authReducer,
    admin: adminReducer,
    territories: territoriesReducer,
    modes: modesReducer,
    contractors: contractorsReducer,
    access_objects: accessObjectsReducer,
    object_groups: objectGroupsReducer,
    requests: requestsReducer,
    approvals: approvalsReducer,
    granted_accesses: grantedAccessesReducer,
    tasks: tasksReducer,
    autopark: autoparkReducer,
    skud: skudReducer,
    docs: docsReducer,
    reports: reportsReducer,
  },
})

const dispatch = store.dispatch.bind(store)
store.dispatch = (action) => {
  if (action && action.type === 'auth_clean') {
    beginLogoutToastGracePeriod()
  }
  return dispatch(action)
}

const router = createHashRouter(
  createRoutesFromElements(
    <Route path="/" element={<Select2NavigationCleanup />}>
      <Route index element={<IndexView />} />
      {authRoutes}
      {adminRoutes}
      {territoriesRoutes}
      {modesRoutes}
      {contractorsRoutes}
      {accessObjectsRoutes}
      {objectGroupsRoutes}
      {requestsRoutes}
      {approvalsRoutes}
      {grantedAccessesRoutes}
      {tasksRoutes}
      {autoparkRoutes}
      {skudRoutes}
      {docsRoutes}
      {reportsRoutes}
    </Route>
  )
);

const HistoryHook = () => {
  useEffect(() => {
    (function(history) {
        var pushState = history.pushState;
        history.pushState = function(state) {
          if (typeof history.onpushstate == "function")  {
            history.onpushstate({ state: state, arguments  });
          }
          return pushState.apply(history, arguments);
        }
    })(window.history);

    window.onpopstate = window.history.onpushstate = function(data) {
      store.dispatch({ type: 'lib_panel_items', data: undefined })
    };
  }, [])
}

installSelect2ScrollFix()

ReactDOM.createRoot(document.getElementById("react-root")).render(
  <React.StrictMode>
    <HistoryHook />
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

